export const fmtDT = (v) => (v ? new Date(v).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fmtD = (v) => (v ? new Date(v).toLocaleDateString([], { dateStyle: "medium" }) : "—");
export const fmtHours = (min) => `${Math.floor((min || 0) / 60)}h ${String((min || 0) % 60).padStart(2, "0")}m`;

export const EVENT_LABEL = {
  drop_off: "Dropped off", pickup: "Picked up", tardy: "Tardy", early_dismissal: "Early dismissal",
  class_in: "In class", class_out: "Out of class", absent: "Marked absent", board: "Boarded bus", alight: "Left bus",
};
export const EVENT_TONE = {
  drop_off: "bg-emerald-100 text-emerald-800", pickup: "bg-blue-100 text-blue-800", tardy: "bg-amber-100 text-amber-800",
  early_dismissal: "bg-violet-100 text-violet-800", absent: "bg-rose-100 text-rose-800", class_in: "bg-emerald-50 text-emerald-700",
  class_out: "bg-slate-100 text-slate-700", board: "bg-amber-50 text-amber-800", alight: "bg-slate-100 text-slate-700",
};

export function EventChip({ type }) {
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-[11px] font-semibold ${EVENT_TONE[type] || "bg-slate-100 text-slate-700"}`}>
      {EVENT_LABEL[type] || type}
    </span>
  );
}

export function Section({ title, children, testid, action }) {
  return (
    <section className="rounded-xl border border-slate-200 bg-white overflow-hidden" data-testid={testid}>
      <div className="px-4 py-2.5 border-b border-slate-100 flex items-center justify-between">
        <div className="text-[11px] font-semibold uppercase tracking-widest text-slate-500">{title}</div>
        {action}
      </div>
      <div>{children}</div>
    </section>
  );
}

export function InfoRow({ label, value, testid }) {
  return (
    <div className="flex items-start justify-between gap-4 px-4 py-2 border-b border-slate-50 last:border-0 text-sm">
      <span className="text-slate-500 shrink-0">{label}</span>
      <span className="text-slate-900 font-medium text-right break-words" data-testid={testid}>{value || <span className="text-slate-300">—</span>}</span>
    </div>
  );
}

export function Stat({ label, value, tone = "", testid }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-center" data-testid={testid}>
      <div className={`font-display text-2xl font-bold ${tone || "text-slate-900"}`}>{value ?? "—"}</div>
      <div className="text-[10px] uppercase tracking-widest text-slate-500 mt-0.5">{label}</div>
    </div>
  );
}

export function Empty({ text }) {
  return <div className="px-4 py-8 text-center text-sm text-slate-400">{text}</div>;
}

export function Row({ children, testid }) {
  return <div className="px-4 py-2.5 border-b border-slate-50 last:border-0 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm" data-testid={testid}>{children}</div>;
}

export const tabCls = "rounded-md px-3 py-1.5 text-xs font-medium data-[state=active]:bg-slate-900 data-[state=active]:text-white text-slate-600 hover:text-slate-900 transition";
